<template>

        <v-container
        class="scroll-y"
        fluid
        >
        <v-row
        align="center"
        justify="center"
        >
        <v-col cols="10" md="10">
          <v-card class="ml-20 mr-20">
            <v-app-bar
            dark
            color="#2C3A47"
            >
            <v-btn icon>
              <v-icon>mdi-memory</v-icon>
            </v-btn>
          <v-toolbar-title>Board Setting</v-toolbar-title>
          <v-spacer></v-spacer>
          <div class="pa-2">
          <v-dialog v-model="dialogEdit" persistent max-width="800px">
            <template v-slot:activator="{ on }">
                <v-btn color="green" v-on="on" outlined="">
                  <v-icon left>mdi-pencil</v-icon> Edit Group
                </v-btn>
            </template>
              <v-card>
                <v-form>
                  <v-card-title>
                    <span class="headline">Board</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-form ref="form" v-model="valid">
                           <v-select
                        :items="group"
                        v-model="boardData.group"
                        item-value="_id"
                        :item-text="
                        (group) => {
                          return (
                            group.name
                          );
                        }"                              
                        :rules="groupRules"
                        label="Group Name"
                        ></v-select>
                        <v-select
                        :items="command"
                        v-model="boardData.cmd"
                        item-value="_id"
                        :item-text="
                        (command) => {
                          const text = (command !== null ? `${command.number} - ${command.name}` : '');

                          return text;
                        }"                              
                        :rules="cmdRules"
                        label="Command Number"
                        ></v-select>
                       
                        <div v-if="command[0]._id.indexOf(boardData.cmd) == 0 || command[5]._id.indexOf(boardData.cmd) == 0
                        || command[6]._id.indexOf(boardData.cmd) == 0 || command[7]._id.indexOf(boardData.cmd) == 0
                        || command[8]._id.indexOf(boardData.cmd) == 0 || command[9]._id.indexOf(boardData.cmd) == 0
                        || command[11]._id.indexOf(boardData.cmd) == 0 || command[13]._id.indexOf(boardData.cmd) == 0 
                        || command[14]._id.indexOf(boardData.cmd) == 0 || command[18]._id.indexOf(boardData.cmd) == 0
                        || command[19]._id.indexOf(boardData.cmd) == 0 || command[20]._id.indexOf(boardData.cmd) == 0
                        || command[21]._id.indexOf(boardData.cmd) == 0 || command[22]._id.indexOf(boardData.cmd) == 0
                        || command[23]._id.indexOf(boardData.cmd) == 0">
                         <v-text-field label="SSID Name*" v-model="boardData.input" :rules="ssidRules" color="#2C3A47"></v-text-field>
                         <v-text-field label="Password*" v-model="boardData.input2" :rules="passwordRules" color="#2C3A47"></v-text-field>
                        </div>
                        </v-form>
                      </v-flex>               
                    </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#2C3A47" dark @click="close1" outlined small>
                      <v-icon left>exit_to_app</v-icon> Close
                    </v-btn>
                    <v-btn color="light-green darken-4" dark @click="updateBoardCmd" outlined small>
                      <v-icon left>mdi-pencil</v-icon> Edit
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
          </v-dialog>
          </div>
          
          <div>
          <v-dialog v-model="dialog" persistent max-width="800px">
            <template v-slot:activator="{ on }">
                <v-btn color="red" v-on="on" outlined="" >
                  <v-icon left>add</v-icon> ADD
                </v-btn>
            </template>
              <v-card>
                <v-form @submit.prevent="saveBoard" ref="boardData" lazy-validation enctype="multipart/form-data" autocomplete="off">
                  <v-card-title>
                    <span class="headline">Board</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-form ref="form" v-model="valid">
                        <v-text-field label="Serial Number*" type="number" v-model="boardData.sn" :rules="snRules" color="#2C3A47" :counter="9"></v-text-field>
                        <v-select
                        :items="command"
                        v-model="boardData.cmd"
                        item-value="_id"
                        :item-text="
                        (command) => {
                          const text = (command !== null ? `${command.number} - ${command.name}` : '');

                          return text;
                        }"                              
                        :rules="cmdRules"
                        label="Command Number"
                        ></v-select>
                        <v-select
                        :items="group"
                        v-model="boardData.group"
                        item-value="_id"
                        :item-text="
                                (group) => {
                                  return (
                                    group.name
                                  );
                                }"                              
                                :rules="groupRules"
                        label="Group Name"
                        ></v-select>
                        <div v-if="command[0]._id.indexOf(boardData.cmd) == 0 || command[5]._id.indexOf(boardData.cmd) == 0
                        || command[6]._id.indexOf(boardData.cmd) == 0 || command[7]._id.indexOf(boardData.cmd) == 0
                        || command[8]._id.indexOf(boardData.cmd) == 0 || command[9]._id.indexOf(boardData.cmd) == 0
                        || command[11]._id.indexOf(boardData.cmd) == 0 || command[13]._id.indexOf(boardData.cmd) == 0 
                        || command[14]._id.indexOf(boardData.cmd) == 0 || command[18]._id.indexOf(boardData.cmd) == 0
                        || command[19]._id.indexOf(boardData.cmd) == 0 || command[20]._id.indexOf(boardData.cmd) == 0
                        || command[21]._id.indexOf(boardData.cmd) == 0 || command[22]._id.indexOf(boardData.cmd) == 0
                        || command[23]._id.indexOf(boardData.cmd) == 0">
                         <v-text-field label="SSID Name*" v-model="boardData.input" :rules="ssidRules" color="#2C3A47"></v-text-field>
                         <v-text-field label="Password*" v-model="boardData.input2" :rules="passwordRules" color="#2C3A47"></v-text-field>
                        </div>
                        </v-form>
                      </v-flex>               
                    </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#2C3A47" dark @click="close" outlined small>
                      <v-icon left>exit_to_app</v-icon> Close
                    </v-btn>
                    <v-btn color="light-green darken-4" dark type="submit" outlined small>
                      <v-icon left>save</v-icon> {{saveDialog}}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
          </v-dialog>
          </div>
            </v-app-bar>
            <v-container>
              <v-card class="mx-auto elevation-19">
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  color="#2C3A47"
                  >
                  </v-text-field>
                </v-card-title>
        <v-data-table
        item-key="id"
        :headers="headers"
        :items="board"
        :search="search"
        >
        <template v-slot:[`item.cmd`]="{ item }">
          {{ ('cmd' in item) && item.cmd !== null ? `${item.cmd.number} - ${item.cmd.name}` : '' }}
        </template>
        <template v-slot:[`item.set`]="{ item }">
          <v-btn color="red" x-small v-if="item.set == 0">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
          <v-btn color="success" x-small v-if="item.set == 1">
            <v-icon small>mdi-check</v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.updatedAt`]="{ item }">
          {{ formatDate(item.updatedAt) }}
        </template>
        <template v-slot:[`item.actions`]="{item}">
          <v-btn color="success" fab x-small @click="editBoard(item)" outlined>
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn color="pink" class="mx-2" fab x-small @click="deleteBoard(item._id)" outlined>
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
        <template v-slot:no-results>
            <v-alert :value="true" color="pink" icon="warning" dark>
              Your Search {{search}} does not exist.
            </v-alert>
        </template>

        </v-data-table>
              </v-card>
            </v-container>
          </v-card>
          <v-snackbar
          v-model="snackbar"
          top
          right
          :color="color"
          >
          {{text}}
          <v-btn
          color="black"
          text
          @click="snackbar = false"
          >
          Dissmiss
          </v-btn>

          </v-snackbar>
        </v-col>

        </v-row>

        </v-container>
  
</template>
<script>
import axios from "axios";
import moment from 'moment';
export default {
  props:{
    source: String
  },
  data: () => ({
    mini: false,
    dialog:false,
    dialogEdit:false,
    fab: false,
    search:'',
    snackbar: false,
    text:'',
    color:'',
    selectedIndex: 0,
    board: [],
    sn: [],
    command: [],
    group: [],
    snRules: [
        v => !!v || 'Serial Number is required',
        v => v.length <= 9 || 'Serial Number needs to be 9 digits',
        v => v.length >= 9 || 'Serial Number needs to be 9 digits',
      ],
    cmdRules: [
        v => !!v || 'Commmand is required',
      ],
    groupRules: [
        v => !!v || 'Group is required',
      ],
    ssidRules: [
        v => !!v || 'SSID is required'
      ],
    passwordRules: [
        v => !!v || 'Password is required'
      ],
    headers: [
        {text: 'Device S/N', value: 'sn', sortable: true},
        {text: 'Group', value: 'group.name', sortable: true},
        {text: 'SSID', value: 'input', sortable: true},
        {text: 'Password/Data', value: 'input2', sortable: true},
        {text: 'Command Number', value: 'cmd', sortable: true},
        {text: 'Modified By', value: 'modifiedBy', sortable: true},
        {text: 'Status', value: 'set', sortable: true},
        {text: 'Last Modified Date', value: 'updatedAt', sortable: true},
        {text: 'Action', value: 'actions', sortable: false, width: '180px'},
    ],
    boardData: {
      sn: '',
      cmd:'',
      group: '',
      input: '',
      input2: '',
      modifiedBy: ''
    },
    default: {
      sn: '',
      cmd:'',
      group: '',
      input: '',
      input2: '',
      modifiedBy: ''
    },
    editedIndex: -1,
  }),
  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogEdit (val) {
      val || this.close1()
    }
  },
  computed: {
    saveDialog() {
      return this.editedIndex === -1 ? 'Save' : 'Edit'
    }
  },
  mounted() {
    this.loadsBoard();
    this.loadsCommand();
    this.loadsGroup();
    this.intervalFetchData();
  },
  methods: {
    intervalFetchData: function () {
            setInterval(() => {    
                this.loadsBoard(),this.loadsCommand(),this.loadsGroup()
                }, 5000);    
        },
    formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a")
  },
  loadsBoard: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/board";
  axios.get(apiURL).then(res => {
    this.board = res.data;
    this.sn = res.data.map((sn) => sn.sn);
  }).catch(error => {
    console.error(error);
  });
  },
 loadsCommand: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/command";
  axios.get(apiURL).then(res => {
    this.command = res.data;
  }).catch(error => {
    console.error(error);
  });
  },
  loadsGroup: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/group";
  axios.get(apiURL).then(res => {
    this.group = res.data;
  }).catch(error => {
    console.error(error);
  });
  },
    onScroll (e) {
      if(typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop(){
      this.$vuetify.goTo(0)
    },
    close(){
      this.dialog = false
      setTimeout(()=>{
        this.boardData = Object.assign({}, this.default)
        this.editedIndex = -1
      }, 300)
    },
    close1(){
      this.dialogEdit = false
      setTimeout(()=>{
        this.boardData = Object.assign({}, this.default)
        this.editedIndex = -1
      }, 300)
    },
    saveBoard: async function(){
        if(this.editedIndex > -1) {
         this.updateBoard();
        }else {
          this.createBoard();
        }
    },
    createBoard(){
      if (this.$refs.form.validate()) {
      let apiURL = process.env.VUE_APP_API + "/api/create-board";
      if(this.sn.indexOf(this.boardData.sn) >= 0){
        this.close();
        this.loadsBoard();
        this.color = 'warning'
        this.text =`${this.boardData.sn} already existed!!`
        this.snackbar = true;
      }
      else {
        axios.post(apiURL, {
        sn: this.boardData.sn,
        cmd: this.boardData.cmd,
        group: this.boardData.group,
        input: this.boardData.input,
        input2: this.boardData.input2,
        status: 0,
        set: 0,
        modifiedBy: this.$keycloak.tokenParsed.given_name
        }).then(() => {
          this.close();
          this.loadsBoard();
          this.color = 'success'
          this.text ='Board has been successfully saved.'
          this.snackbar = true;
        }).catch(error => {
          console.log(error)
        });
       }
    }},
    editBoard(item) {
      this.editedIndex = this.board.indexOf(item)
      this.boardData = Object.assign({}, item)
      this.dialog = true
    },
    updateBoard(){
      if (this.$refs.form.validate()) {
      let apiURL = process.env.VUE_APP_API + `/api/update-board/${this.boardData._id}`;
      axios.post(apiURL, {
        sn: this.boardData.sn,
        cmd: this.boardData.cmd,
        group: this.boardData.group,
        input: this.boardData.input,
        input2: this.boardData.input2,
        status: 0,
        set: 0,
        modifiedBy: this.$keycloak.tokenParsed.given_name
        }).then((res) => {
        console.log(res)
        this.close();
        this.loadsBoard();
        this.color ='info'
        this.text = 'Board has been modified.'
        this.snackbar = true;
      }).catch(error => {
        console.log(error)
        console.log(this.$route.params.id)
      })
    }},
    updateBoardCmd(){
      let apiURL = process.env.VUE_APP_API + `/api/update-board/group/${this.boardData.group}`;
      axios.post(apiURL, {
        cmd: this.boardData.cmd,
        input: this.boardData.input,
        input2: this.boardData.input2,
        status: 0,
        set: 0,
        modifiedBy: this.$keycloak.tokenParsed.given_name
        }).then((res) => {
        console.log(res)
        this.close1();
        this.loadsBoard();
        this.color ='info'
        this.text = 'Board Command Group has been modified.'
        this.snackbar = true;
      }).catch(error => {
        console.log(error)
        console.log(this.$route.params.id)
      })
    },
    deleteBoard(id){
              this.$swal({
                    title: 'Are you sure?',
                    text: "You will not be able to go back",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#00b894',
                    cancelButtonColor: '#d63031',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    }).then((result) => {
                        // Send request to the server
                         if (result.value) {
                               try {
                let apiURL = process.env.VUE_APP_API + `/api/delete-board/${id}`;
                let indexOfArrayItem = this.board.findIndex(i => i._id === id);
                axios.delete(apiURL).then(() => {
                        this.board.splice(indexOfArrayItem, 1);
                    }).catch(error => {
                        console.log(error)
                    });
                 this.$swal(
                         'Deleted!',
                         'Board has been deleted.',
                         'success'
                        )
                        //Notification error
                this.color = 'error'
                this.text = "Board has been deleted."
                this.snackbar = true;
                //Notification error
            }catch (error) {
             this.$swal("Failed!", "There was something wrong.", "warning");
            }
                         }
                    })
  
            },
  },

}
</script>

<style>
  .otp-input {
    width: 30px;
    height: 40px;
    margin: 0 4px;
    font-size: 20px;
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;

  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>